import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { selectCategoriesListItems } from '../../../../../redux/categories/selector';
import { categories } from '../../../../../redux/categories/action';
import { products } from '../../../../../redux/products/action';
import { selectListItems } from '../../../../../redux/library/selector';
import * as R from 'ramda'
import { selectOrganizationUnitsListItems } from '../../../../../redux/organizationUnits/selector';
import { selectTemplatesListItems, selectTemplatesQueryItems } from '../../../../../redux/templates/selector';
import { selectTenantFunctionsListItems } from '../../../../../redux/tenant-functions/selector';
import { tenantFunctions } from '../../../../../redux/tenant-functions/action';
import { templates } from '../../../../../redux/templates/action';
import TemplateComponent from '../components/template.component';
import { websites } from '../../../../../redux/websites/action';
import { accountWebPages } from '../../../../../redux/web-pages/action';
import { selectWebsitesListItems } from '../../../../../redux/websites/selector';
import { selectAccountWebPagesListItems } from '../../../../../redux/web-pages/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { organizationUnits } from '../../../../../redux/organizationUnits/action';
import { selectProductsListItems } from '../../../../../redux/products/selector';
import { selectOrgRegistriesListItems } from '../../../../../redux/org-registries/selector';
import { orgRegistries } from '../../../../../redux/org-registries/action';
import { selectDiscountsListItems } from '../../../../../redux/policy/discounts/selector';
import { selectPolicyCollectionsListItems } from '../../../../../redux/organization/collections/selector';
import { selectDbasListItems } from '../../../../../redux/dbn-cloud/dbas/selector';
import { dbas } from '../../../../../redux/dbn-cloud/dbas/action';
import { policyCollections } from '../../../../../redux/organization/collections/action';
import { discounts } from '../../../../../redux/policy/discounts/action';

let currentChange: any = {}
const ManagementTemplate = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectTemplatesQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoriesLists = useSelector(selectCategoriesListItems)
  const productsLists = useSelector(selectProductsListItems)
  const organizationUnitsLists = useSelector(selectOrganizationUnitsListItems)
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const discountsLists = useSelector(selectDiscountsListItems)
  const collectionPolicyLists = useSelector(selectPolicyCollectionsListItems)
  const channelLists = useSelector(selectListItems)
  const templatesItems = useSelector(selectTemplatesListItems)
  const websitesItems = useSelector(selectWebsitesListItems)
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  const accountItems = useSelector(selectAccountsListItems)
  const orgRegistryItems = useSelector(selectOrgRegistriesListItems)
  const dbasItems = useSelector(selectDbasListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedTemplate,
    setSelectedTemplate
  ] = useState<any>({
    BodyContent: '',
    DesignFileurls: [],
    Attachmenturls: [],
    MappedEntities: []
  })
  const [
    selectedFunctions,
    setSelectedFunctions
  ] = useState<any>([])

  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);

  const [
    templateImageIndex,
    setTemplateImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const fetchTemplateyId = () => {
    dispatch(templates.query({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/templates/fetch-detail`, entity: 'templates', jsonData: {
        Context: {},
        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  useEffect(
    () => {
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'cards', jsonData: {
        }
      })).then(() => {
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          }
        }))
      }).then(() => {
        dispatch(categories.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
          entity: 'categories',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(dbas.list({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
          entity: 'dbas',
          jsonData: {

          }
        }))
      }).then(() => {
        dispatch(orgRegistries.list({
          url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/org-registries/fetch`,
          entity: 'orgRegistries',
          jsonData: {
            "Context": {},
            "Records": [{ IsBothTenantANDDBNBased: true }],
            "Pagination": {

            }
          }
        }))
      }).then(() => {
        dispatch(products.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
          entity: 'products',
          jsonData: {
          }
        }))
      }).then(() => {
        dispatch(accounts.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/rms/accounts/fetch`,
          entity: 'accounts',
          jsonData: {
            Context: {},
            Records: [
              {
                IsProxyAccount: false
              }
            ],
            Pagination: {
            }

          }
        }))
      }).then(() => {
        dispatch(policyCollections.list({
          url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/organization/management/collections/fetch-resultant-policy`,
          entity: 'policyCollections',
          jsonData: {
            Context: {},
            Records: [{}],
            Pagination: {
            }
          }, options: { key: 'management-product-collection' }
        }))
      }).then(() => {
        dispatch(discounts.list({
          url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/merchandising/management/discounts/list`,
          entity: 'discounts',
          jsonData: {
            Context: {},
            Records: [{}],
            Pagination: {
            }
          }, options: { key: 'management-product-collection' }
        }))
      }).then(() => {
        dispatch(tenantFunctions.list({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantDomainFunctions', jsonData: {
            Filters: [
              {
                FieldName: 'IsTemplateMappingEnabled',
                FieldText: 'TemplateMappingEnabled',
                FieldType: 'boolean',
                FilterOperatorId: 1,
                FieldValue: true
              }
            ]


          }
        }))
      })
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {

        }
      }));
      if (parmas?.id > 0) {
        fetchTemplateyId()
        setIsLoading(false)
      }
      else {
        const localSelectedFunction = addNewRow({ selectedFunctionArg: selectedFunctions });
        setSelectedFunctions(localSelectedFunction)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )


  useEffect(
    () => {

      if (isQuery) {
        setSelectedTemplate(queryItems?.result?.items)
        const localSelectedService = addNewRow({ selectedFunctionArg: queryItems?.result?.items?.MappedEntities });
        setSelectedFunctions(localSelectedService)
        const urls = queryItems?.result?.items?.Attachmenturls?.map(o => { return { FileTypeId: 10, FileMappingURL: o } })
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: urls });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
  const handleFormAttachmentItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }

  const deleteSelectedFunctions = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      selectedFunctions?.splice(
        index,
        1
      )
    }
    handleClose()
  }
  const addNewRow = ({ selectedFunctionArg }: any) => {
    const localSelectedFunction = deepCopy(selectedFunctionArg)
    const newsFunctions = {
      Id: 0,
      OwnerTypeId: 0,
      OwnerId: 0,


    }
    if (localSelectedFunction.length === 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerTypeId !== 0 ||
      localSelectedFunction[localSelectedFunction?.length - 1]?.OwnerId !== ''
    ) {
      localSelectedFunction?.push(newsFunctions)
    }

    return localSelectedFunction
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedTemplate({ ...selectedTemplate, [field]: event });
  }
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(selectedFunctions);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setSelectedFunctions(items);
  }

  const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileMappingURL !== ''
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }

    return localSelectedmedia
  }
  const setCombinationmediaInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileMappingURLDONE'
    setMediaFiles(localSelectedMedia)
  }
 console.log('mediaData',mediaFiles)


  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setTemplateImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'Campaign',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
    mediaFiles[templateImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))

  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    selectedTemplate.IsApproved = true;
    selectedFunctions.splice(
      selectedFunctions.length - 1,
      1
    );
    mediaFiles?.splice(
      mediaFiles.length - 1,
      1
    )

    const mediaData: any = mediaFiles?.map((item: any) => {
      const itemData = {
        attachementURL: item?.FileMappingURL
      }
      return itemData
    })

    selectedTemplate.Attachmenturls = mediaData.map((data: any) => data.attachementURL);

    selectedTemplate.MappedEntities = selectedFunctions
    if (parmas?.id > 0) {
      await dispatch(templates.resetAction({ actionType: 'update' }))
      await dispatch(templates.update({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates`, entity: 'templates', jsonData: {
          Context: {},
          Records: [
            selectedTemplate
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(templates.resetAction({ actionType: 'create' }))
      await dispatch(templates.create({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates`, entity: 'templates', jsonData: {
          Context: {},
          Records: [
            selectedTemplate
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const setCombinationInfo = async () => {
    let localSelectedFunction = deepCopy(selectedFunctions)
    localSelectedFunction.splice(
      currentChange.idx,
      1,
      { ...localSelectedFunction[currentChange.idx] }
    );
    localSelectedFunction = addNewRow({ selectedFunctionArg: localSelectedFunction });
    currentChange.field = 'OwnerTypeIdDONE'
    setSelectedFunctions(localSelectedFunction)
  }

  useEffect(
    () => {
      if (currentChange.field === 'OwnerId') {
        setCombinationInfo()
      }
    },
    [selectedFunctions]
  )
  const back = () => {
    navigate('/management/cms/templates')
  }

  useEffect(() => {

  }, [selectedTemplate]
  )
  useEffect(
    () => {
      if (currentChange.field === 'FileMappingURL') {
        setCombinationmediaInfo()
      }
      console.log('mediafiles', mediaFiles)
    },
    [mediaFiles]
  )

  const formatWebpagesListData = (data: any) => {
    return _.map(data, (product: any) => {
      const item = {
        Id: product?.Id,
        WebpageName: `${product?.Name} : ${product?.AccountName}`,
      };
      return item
    });
  };
  return (
    <>
      {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
        folder={openFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleSubmit}
        type={openFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <TemplateComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedTemplate={selectedTemplate}
          selectedFunctions={selectedFunctions}
          handleFormSubmit={handleFormSubmit}
          back={back}
          categories={categoriesLists?.result?.items}
          accounts={accountItems?.result?.items}
          channels={channelLists?.result?.items}
          organizationUnits={organizationUnitsLists?.result?.items}
          discounts={discountsLists?.result?.items}
          collectionPolicies={collectionPolicyLists?.result?.items}
          products={productsLists?.result?.items}
          handleFormItemChange={handleFormItemChange}
          deleteSelectedFunctions={deleteSelectedFunctions}
          tenantFunction={tenantfunctionsLists?.result?.items}
          templates={templatesItems?.result?.items}
          id={parmas?.id}
          changeImage={changeImage}
          mediaFiles={mediaFiles}
          handleFormAttachmentItemChange={handleFormAttachmentItemChange}
          websites={websitesItems?.result?.items}
          webpages={formatWebpagesListData(webPagesItems?.result?.items)}
          dbas={dbasItems?.result.items}
          orgRegistries={orgRegistryItems?.result.items}
          tenantFunctions={(tenantfunctionsLists?.result?.items || []).flatMap(
            (func: any) =>
              (func.Entities || []).map((entity: any) => ({
                label: entity.EntityName,       // what to show in dropdown
                value: entity.Id,               // OwnerTypeId
                FunctionName: func.FunctionName, // used for conditional logic
              })))}

        />}
    </>
  )

}

export default ManagementTemplate;